import GenerateRoadmap from "../../containers/ManegeProcedure/GenerateRoadmap";
import { useDialog } from "../../contexts/DialogContext";
import { useModal } from "../../contexts/ModalContext";
import { validateArray } from "../../utils/validate";
import { Tooltip } from "react-tippy";
import { H3, Anchor } from "../../components/Text";
import { DialogConfirmation } from "../../components/Modal";
import ListDocument from "../../components/common/ListDocument";
import ListDocumentVerify from "../../components/common/ListDocumentVerify";
import { ExportTransferPDF } from "../../containers/ManegeProcedure/ExportTransferPDF";

const TableLisDocument = ({ listButton, procedure }) => {
  const { openDialog, dialogClose } = useDialog();
  const { openModal, onClose } = useModal();

  function generateRoadmap(procedure) {
    openDialog(<GenerateRoadmap procedure={procedure} />);
  }

  function handleExportTransfer(procedure) {
    openDialog(<ExportTransferPDF procedure={procedure} />);
  }

  function handleBreakdownDocument(procedure) {
    openDialog(
      <DialogConfirmation
        children={
          <H3>¿Estas seguro que desea unir los documentos en un PDF?</H3>
        }
        onClose={dialogClose}
        method="post"
        url={`/Utility/joinPdfs/${procedure.id}`}
        texBtn="Generar"
        handleSuccess={viewLinkDocument}
      />
    );
  }

  function handleExtractSectionL(procedure) {
    openDialog(
      <DialogConfirmation
        children={
          <H3>¿Extraer la sección L?</H3>
        }
        onClose={dialogClose}
        method="post"
        url={`/files/sectionL/${procedure.id}?fieldId=${procedure.procedureTypeId === 1 ? 292 : 285}`}
        texBtn="Extraer"
        handleSuccess={extractSuccess}
      />
    );
  }

  function viewLinkDocument(data) {
    openDialog(
      <div className="w-[300px]">
        <H3>Archivo generado</H3>
        <center>
          <Anchor
            className="text-[#264fbe] text-[1.4rem]"
            href={data.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Descargar archivo
          </Anchor>
        </center>
        <br />
      </div>
    );
  }
  function extractSuccess(data) {
    openDialog(
      <div className="w-[300px] mb-10">
        <H3>Documentos descargados correctamente!</H3>
      </div>
    );
  }

  function handleDocument(procedure) {
    openModal(<ListDocument procedure={procedure} />);
  }

  function handleDocumentVerify(procedure) {
    openModal(<ListDocumentVerify procedure={procedure} />);
  }

  let listGeneralButtons = [
    {
      label: "Solicitud de transferencia (Exportación) PDF",
      icon: "far fa-file-pdf",
      Name: "trz-010-generar-solicitudes",
      action: handleExportTransfer,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Generar hoja de ruta",
      icon: "fas fa-route",
      Name: "trz-001-hojaDeRuta",
      action: generateRoadmap,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Desglose de documentos",
      icon: "fas fa-print",
      Name: "trz-007-desgloseDeDocumentos",
      action: handleBreakdownDocument,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Ver documentos",
      icon: "fa-solid fa-folder",
      Name: "trz-008-verDocumentos",
      action: handleDocument,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Verificar documentos",
      icon: "fa-solid fa-list-check",
      Name: "trz-009-verificarDocumentos",
      action: handleDocumentVerify,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Desglose de documentos",
      icon: "fas fa-print",
      Name: "trz-007-desgloseDeDocumentos",
      action: handleBreakdownDocument,
      color: "text-[#1d4ed8]",
    },
    {
      label: "Extraer documentos (L)",
      icon: "far fa-file",
      Name: "trz-011-extraer-seccion-l",
      action: handleExtractSectionL,
      color: "text-[#1d4ed8]",
    },
  ];

  return (
    <>
      {validateArray(listButton)
        ? listButton.map((btn, index) => {
          const button = listGeneralButtons.find(
            (element) => element.Name === btn.Name
          );
          if (button === undefined) {
            return null;
          }
          return (
            <div
              key={index}
              className={`${button.color} text-xl cursor-pointer`}
              onClick={() => button.action(procedure)}
            >
              <Tooltip
                title={button.label}
                position="right"
                trigger="mouseenter"
              >
                <i className={button.icon + " p-1"}></i>
              </Tooltip>
            </div>
          );
        })
        : null}
    </>
  );
};

export default TableLisDocument;
